import { connect } from 'react-redux';
import { doStartAppSpecificPasswordInstallMode } from '../../../actions/Installation/InstallMode/AppSpecificPassword';
import Discover from '../components/Discover';
const mapStateToProps = state => ({
  locallyInstalledApps: state.installedApps.locallyInstalledApps,
  globallyInstalledApps: state.installedApps.globallyInstalledApps
});
const mapDispatchToProps = dispatch => ({
  openAppSpecificPasswordDialog: _ref => {
    let {
      name
    } = _ref;
    return dispatch(doStartAppSpecificPasswordInstallMode({
      name
    }));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(Discover);